<template>
    <div class="modal fade" ref="totpModal" id="totpModal" tabindex="-1" aria-labelledby="totpModal" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <form class="modal-content" id="totpForm" @submit.prevent="handleSubmit">
                <div class="modal-header text-bg-primary">
                    <h5 class="modal-title">Double authentification par application mobile</h5>
                    <button type="button" class="btn-close text-light" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>Scannez ce QR-CODE depuis votre application mobile d'authenfication</p>
                        <qrcode-vue :size="200" :value="qrcode"></qrcode-vue>
                    </div>
                    <div class="mb-2">
                        <PasswordComponent label="Secret" :required="false" :readonly="true" v-model="secret" />
                        <label class="mt-2 form-label">Code</label>
                        <input class="form-control" type="code" required :placeholder="$t('mfa.totpCodePlaceholder')" v-model="code">
                    </div>
                    <div class="mt-3 d-flex justify-content-between">
                        <button type="button" class="btn btn-secondary" ref="closeButton" data-bs-dismiss="modal">Annuler</button>
                        <span v-if="errorMessage" class="custom-error-msg">{{ errorMessage }}</span>
                        <button type="submit" class="btn btn-primary">Valider</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Modal } from 'bootstrap';
import QrcodeVue from 'qrcode.vue'
import PasswordComponent from '@/components/password.vue';
import base32 from 'base32.js';

export default {
    name: 'TotpModal',
    components: {
        QrcodeVue,
        PasswordComponent,
    },
    props: {
        action: {
            type: Function,
            required: true
        }
    },
    setup(props) {
        const code = ref("");
        const totpModal = ref(null);
        let modalInstance = null;
        const errorMessage = ref("");
        const message = ref("");
        const secret = ref("");
        const qrcode = ref("");
        const encodedSecret = ref("");

        const generateTOTPSecret = () => {
            const randomBytes = new Uint8Array(20);
            window.crypto.getRandomValues(randomBytes);
            secret.value = Array.from(randomBytes, byte => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
            return base32.encode(randomBytes);
        }

        onMounted(() => {
            if (totpModal.value) {
                modalInstance = new Modal(totpModal.value, { backdrop: 'static' });
            }
        });

        const show = (email) => {
            if (modalInstance) {
                code.value = "";
                errorMessage.value = "";
                encodedSecret.value = generateTOTPSecret();
                qrcode.value = `otpauth://totp/HaxoSetup:${email}?secret=${encodedSecret.value}&issuer=Haxo`;
                modalInstance.show();
            }
        };

        const hide = () => {
            if (modalInstance) {
                modalInstance.hide();
            }
        };

        const showError = (msg) => {
            errorMessage.value = msg;
        };

        const handleSubmit = () => {
            hide();
            const totp = {code: code.value, secret: encodedSecret.value};
            props.action(totp);
        };

        return {
            handleSubmit,
            errorMessage,
            showError,
            totpModal,
            message,
            secret,
            qrcode,
            show,
            hide,
            code,
        };
    },
}
</script>
